function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  }
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/**
 * Checks if passing action is START or END (SUCCESS, ERROR) of an async action.
 * If so stores it in pendingActions state when start or removes it if end.
 */
var middleware = function middleware() {
  var userOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (_ref) {
    var dispatch = _ref.dispatch;
    return function (next) {
      return function (action) {
        // Dispatched empty action
        if (!action) return action;
        var options = _objectSpread({
          actionStartSufix: 'START',
          actionSuccessSufix: 'SUCCESS',
          actionErrorSufix: 'ERROR'
        }, userOptions);
        var ignoredActions = ['ASYNC_ACTION'].concat(_toConsumableArray(options.ignoredActions || []));
        var actionStartSufix = options.actionStartSufix,
          actionSuccessSufix = options.actionSuccessSufix,
          actionErrorSufix = options.actionErrorSufix;
        var type = action.type;
        if (type.endsWith("_".concat(actionStartSufix))) {
          var actionName = type.substr(0, type.lastIndexOf("_".concat(actionStartSufix)));
          if (ignoredActions.indexOf(actionName) !== -1) return next(action);
          dispatch({
            type: 'ADD_PENDING_ACTION',
            payload: {
              actionName: actionName
            }
          });
        }
        if (type.endsWith("_".concat(actionSuccessSufix))) {
          var _actionName = type.substr(0, type.lastIndexOf("_".concat(actionSuccessSufix)));
          if (ignoredActions.indexOf(_actionName) !== -1) return next(action);
          dispatch({
            type: 'REMOVE_PENDING_ACTION',
            payload: {
              actionName: _actionName
            }
          });
        }
        if (type.endsWith("_".concat(actionErrorSufix))) {
          var _actionName2 = type.substr(0, type.lastIndexOf("_".concat(actionErrorSufix)));
          if (ignoredActions.indexOf(_actionName2) !== -1) return next(action);
          dispatch({
            type: 'REMOVE_PENDING_ACTION',
            payload: {
              actionName: _actionName2
            }
          });
        }
        return next(action);
      };
    };
  };
};
export default middleware;